import './Tag.css';
import React, { ReactNode } from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

export interface Props extends GlobalProps {
  accessory?: ReactNode;
  text?: string;
  title?: string;
  backgroundColor?: string;
  squared?: boolean;
  size?: TagSize;
}

export type TagSize = 'small' | 'regular' | 'large';

export function Tag({
  accessory,
  text,
  title,
  backgroundColor,
  style,
  className,
  squared,
  size = 'regular',
}: Props): JSX.Element {
  return (
    <div
      className={classnames('tag', `tag--${size}`, { 'tag--squared': squared }, className)}
      style={{
        backgroundColor,
        ...style,
      }}
    >
      <div className="tag__text" title={title ?? text}>
        {text}
      </div>
      {accessory}
    </div>
  );
}
